import objectPath from 'object-path';
import { AlmeState } from '../../../../wireup/AlmeState';
import { HideEndChatWarningAction, ShowEndChatWarningAction, UpdateChatSessionStateAction } from '../actions/actions';
import { settings } from '../../../../settings/settings-util';

export default function reduce(state: AlmeState, action: HideEndChatWarningAction | ShowEndChatWarningAction | UpdateChatSessionStateAction): AlmeState {
    let newState, stateLocation;
    let sessionState;
    switch (action.type) {
        case "HIDE_END_CHAT_WARNING":
            stateLocation = action.payload.stateLocation;
            newState = Object.assign({}, state);
            objectPath.set(newState, stateLocation, false);

            return newState;

        case "SHOW_END_CHAT_WARNING":
            stateLocation = action.payload.stateLocation;
            newState = Object.assign({}, state);
            objectPath.set(newState, stateLocation, true);

            return newState;

        case "UPDATE_CHAT_SESSION_STATE":
            sessionState = action.payload.sessionState;
            if (!sessionState || (sessionState !== settings.livechat.sessionState.online && sessionState !== settings.livechat.sessionState.queued)) {
                newState = Object.assign({}, state);
                if (newState && newState.EndChatWarning) {
                    newState.EndChatWarning.visible = false;
                } else {
                    newState.EndChatWarning = {
                        visible: false,
                    };
                }
                return newState;
            }
            return state;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-endchat-warning-overlay/src/reducers/index.ts